import { useEffect } from 'react'
import { Link } from 'react-router'
import LogoPDF from "../../PDF.svg";
import OrderBuy from "./Components/OrderBuy/OrderBuy";
import Tracking from "./Components/OrderBuy/Tracking";
import History from "./Components/OrderBuy/History";
import ViewFile from "./Components/Files/ViewFile";
import './css/linkpanel.css'
import './css/linkpanel-phone.css'

export default function LinkPanel(props) {

    useEffect(() => {
        document.getElementById('Tit').innerText = 'KMP-' + props.idC;
    }, [props])

    return (
        <div className='LinkPanel'>
            <table>
                <thead>
                    <tr>
                        <td colSpan={3}>
                            Status de Orden
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr className='Cotizacion'>
                        <td>Cotizacion</td>
                        <td>KMP-{props.data.idCotizacion}</td>
                        <td>
                            <Link to={`/LinkCot/${props.hash}/${props.idC}`} target="_blank" params={{ fromFeed: true }}>
                                <img src={LogoPDF} alt={`cotmain${props.data.idCotizacion}`} />
                            </Link>
                        </td>
                    </tr>
                    {
                        props.data.oc.map((oc, ioc) => (
                            <tr className='Orden' key={ioc}>
                                <td colSpan={3}>
                                    <OrderBuy hash={props.hash} id={oc.idCotizacion_OrdenCompra} name={oc.name} />
                                </td>
                            </tr>
                        ))
                    }
                    {
                        props.data.files.length > 0 ?
                            <tr className='Orden'>
                                <td colSpan={3}>
                                    <table className='TableFiles'>
                                        <thead>
                                            <tr>
                                                <td colSpan={3}>Archivos</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                props.data.files.map((fl, ifl) => (
                                                    <ViewFile key={ifl} data={fl} />
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            :
                            ''
                    }
                    {/* {
                        props.data.files.map((fl, ifl) => (
                            
                                    <ViewFile key={ifl} data={fl}/>
                              
                        ))
                    } */}
                    {
                        props.data.trk.map((trk, itrk) => (
                            <tr className='Track' key={itrk}>
                                <td colSpan={3}>
                                    <Tracking key={itrk} mmsi={trk.mmsi} Traking={trk.Traking} web={trk.web} Vessel={trk.Vessel}>
                                        {
                                            trk.history.map((his, ihis) => (
                                                <History key={ihis} Title={his.Title} Desc={his.Desc} Date={his.Fecha} />
                                            ))
                                        }
                                    </Tracking>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}
